export default __webpack_public_path__ + "static/media/small-calendar-2.225ed8c9.svg";